var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCancelSharing = function SvgCancelSharing(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "cancel_sharing_svg__cancel_x5F_sharing",
    x: 0,
    y: 0,
    viewBox: "0 0 15.847 12.796",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cancel_sharing_svg__st0{fill:#414a5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.69 5.804-1.247-1.247 1.245-1.245a.44.44 0 0 0 0-.624l-.623-.623a.44.44 0 0 0-.624 0L13.196 3.31 11.95 2.064a.44.44 0 0 0-.624 0l-.623.623a.44.44 0 0 0 0 .624l1.246 1.246-1.248 1.248a.44.44 0 0 0 0 .624l.623.623a.44.44 0 0 0 .624 0l1.246-1.246 1.247 1.247a.44.44 0 0 0 .624 0l.624-.624a.44.44 0 0 0 .001-.625M5.6 6.4a3.2 3.2 0 1 0-3.2-3.2 3.2 3.2 0 0 0 3.2 3.2m2.239.8H7.42a4.35 4.35 0 0 1-3.644 0h-.417A3.36 3.36 0 0 0 0 10.557V11.6a1.2 1.2 0 0 0 1.2 1.2H10a1.2 1.2 0 0 0 1.2-1.2v-1.04A3.36 3.36 0 0 0 7.84 7.2z",
    className: "cancel_sharing_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCancelSharing);
export default ForwardRef;